import React, { useEffect, useState } from 'react'
import { DocWithPreview } from '../../Common/DocWithPreview'
import { Box, Checkbox, FormControlLabel, Grid, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import TextLabel from '../../Common/CommonTextLabel'
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { BucketURL } from '../../../ApiSetup/Api';
import CommonTextField from '../../Common/CommonTextField';
import dayjs from 'dayjs'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CommonTextArea from '../CommonTextArea';
import ButtonOutlined from '../../Common/ButtonOutlined';
import ButtonContained from '../../Common/ButtonContained';
import CommonCheckBox from '../CommonCheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Regex } from '../../../Utils/regex';
import { checkAccess, getImageUrl } from '../../../Utils/handler';
import { useSelector } from 'react-redux';
import { showLoader } from '../../../Redux/Slices/loaderSlice';
import { getAvailableAccess } from '../../../Redux/Actions/action';
import CommonDropDown from '../../Common/CommonDropDown';
import { idProofTypes } from '../../../Utils/enum';
import ReUploadModal from '../../Common/ReUploadModal';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import sessionStoreUtil from '../../../ApiSetup/Localstorage';

const useStyles = makeStyles()((theme) => {

    return {
        gridBorder: {
            background: theme.palette.secondary.main,
            border: `2px dashed ${theme.palette.bgLightBlack.main}`,
            padding: "10px", // Default value
            borderRadius: "12px",

        },
    }
})
const IdProof = ({ data, isEdit, setIsEdit, setImagePreView, setData, handleStatusChange, _updateMember, handleInputChange, setValu, handleChange, errors, dataAccess,
    handleUpload, openIdProof, setOpenIdProof }) => {
    const theme = useTheme()
    const { pathname } = useLocation()
    const startPathname = pathname?.split('-')[0];
    const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};

    return (
        <Grid container item xs={12} >

            <Grid item xs={12}>
                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"ID Proof"} />
            </Grid>

            <Grid item sm={12} xs={12}>
                <Box mx={1} onClick={() => setImagePreView({ isOpen: true, link: getImageUrl(data?.uploadDocuments?.idProof?.idProofImage) })}>
                    <DocWithPreview
                        docArray={data?.uploadDocuments?.idProof?.idProofImage?.length > 0 ? data?.uploadDocuments?.idProof?.idProofImage : []}
                        docName={"ID Proof"}
                        title='ID Proof'
                    />
                    {((checkAccess(startPathname, dataAccess, 'Reupload Button')) && isEdit.idProof) && <ButtonOutlined
                        startIcon={<CloudSyncOutlinedIcon />}
                        border={"none"}
                        width={"auto"}
                        text={"Reupload"}
                        padding={{ xs: "5px 10px", md: "5px 10px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "30px", sm: "30px" }}
                        onClick={() => { setOpenIdProof(true) }}
                    />}
                </Box>
            </Grid>

            <Grid container spacing={1} mt={2}>
                <Grid item xs={12} sm={6}>
                    <CommonDropDown
                        notShowSelect
                        type="text"
                        text={'ID Proof Type'}
                        name={'idProofType'}
                        value={data?.uploadDocuments?.idProof?.idProofType || ""}
                        values={idProofTypes?.map((e) => e?.label) || []}
                        placeholder={`Select Id Proof`}
                        width={"100%"}
                        valid
                        onChange={(e) => {
                            const { value, name } = e?.target
                            setData(prevData => ({
                                ...prevData,
                                uploadDocuments: {
                                    ...prevData.uploadDocuments,
                                    ['idProof']: {
                                        ...(prevData.uploadDocuments['idProof'] || {}),
                                        [name]: value?.trimStart(),
                                    }
                                }
                            }));
                        }}
                        disabled={!isEdit.idProof}
                    />
                    <TextLabel color="error" title={!data?.uploadDocuments?.idProof?.idProofType ? errors?.idProofType : ""} />
                </Grid>

                <Grid item xs={12}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
                        {checkAccess(startPathname, dataAccess, 'Edit Action') &&
                            <ButtonContained
                                backgroundColor={!isEdit.idProof ? theme.palette.primary.main : theme.palette.success.main}
                                width={"auto"}
                                text={isEdit.idProof ? "Save" : "Edit"}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px" }}
                                onClick={() => { setIsEdit({ idProof: !isEdit?.idProof }) }}
                            />
                        }
                        {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                <ToggleButtonGroup
                                    color={data?.idProof?.status == "Approved" ? "success" : "error"}
                                    value={data?.idProof?.status}
                                    exclusive
                                    aria-label="Platform"
                                    size='small'
                                >
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "idProof", "Approved")}>
                                        {data?.idProof?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "idProof", "Rejected")}>
                                        {data?.idProof?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        }
                        {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                            data?.verificationStatus == "Approved" && <ButtonOutlined
                                width={"auto"}
                                text={"Approved"}
                                border={"1px dashed green"}
                                color={'green'}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px", md: "30px" }}
                                endIcon={<CheckCircleIcon />}
                            />
                        }
                    </Box>
                </Grid>


                {data?.verificationStatus !== "Approved" && data?.idProof?.status == "Rejected" && <Grid item xs={12}>
                    <CommonTextArea
                        label="Reason"
                        value={data?.idProof?.reason}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        name='reason'
                        onChange={(e) => handleInputChange(e, "idProof")}
                        rows={2}
                        disabled={user?.organisationName !== "PPSK"}
                    />
                </Grid>}

                {/* 
                <Grid item xs={12} display={"flex"} justifyContent={"flex-end"} gap={1}>
                    <ButtonOutlined
                        width={"auto"}
                        text={"Cancel"}
                        color={"#3E4094"}
                        lineHeight={"24.5px"}
                        backgroundColor={"#fff"}
                        border={"1px solid #3E4094"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => navigate("/admin/documents")}
                    />

                    <ButtonContained
                        width={"auto"}
                        text={"Confirm"}
                        lineHeight={"24.5px"}
                        padding={{ xs: "5px 10px", md: "10px 20px" }}
                        fontSize={{ xs: "12px", md: "14px" }}
                        height={{ xs: "40px", sm: "40px" }}
                        onClick={() => data?.verificationStatus === "Approved" ? setValue("3") : _updateMember("3")}
                    />
                </Grid> */}
            </Grid>

            {openIdProof &&
                <ReUploadModal
                    multiple
                    open={openIdProof}
                    handleClose={() => setOpenIdProof(false)}
                    onSave={() => setOpenIdProof(false)}
                    text={"ID Proof (આઈડી પ્રૂફ)"}
                    name={"idProofImage"}
                    onChange={(e) => handleUpload(e, "uploadDocuments", "idProof")}
                    imageValue={data?.uploadDocuments?.idProof?.idProofImage}
                />}

        </Grid>
    )
}

export default IdProof
